import { Col, Placeholder, Stack } from 'react-bootstrap';

export const CandidateDetailSkeleton = () => {
	return (
		<>
			<Stack className="applicants-list-box h-100">
				<div className="d-flex position-relative gap-3">
					<div className="applicants-info d-flex flex-column flex-sm-row align-items-sm-center gap-2 gap-md-3 flex-1">
						<div className="applicants-img rounded-circle"></div>
						<Stack className="gap-1 justify-content-center">
							<Placeholder animation="glow">
								<Placeholder xs={12} size="lg" />
								<Placeholder xs={12} size="sm" />
								<Placeholder xs={12} />
							</Placeholder>
						</Stack>
					</div>
					<div className="applicants-info-actions d-flex gap-3">
						<Placeholder.Button variant="primary" className="edit-btn p-0 rounded-circle" />
						<Placeholder.Button
							variant="primary"
							className="filled-btn fav-btn rounded-pill lh-1"
						/>
					</div>
				</div>
				<div className="applicants-description">
					<Placeholder animation="glow">
						<Placeholder xs={12} />
						<Placeholder xs={12} />
					</Placeholder>
				</div>
				<div className="applicants-about">
					<Placeholder animation="glow">
						<Placeholder xs={3} /> <Placeholder xs={4} />
					</Placeholder>
				</div>
				<div className="applicants-skills-list">
					<Placeholder animation="glow">
						<Placeholder xs={1} /> <Placeholder xs={1} /> <Placeholder xs={1} />{' '}
						<Placeholder xs={1} /> <Placeholder xs={1} /> <Placeholder xs={1} />{' '}
						<Placeholder xs={1} />{' '}
					</Placeholder>
				</div>
				<div className="applicants-actions d-flex gap-2 gap-md-3 flex-column flex-sm-row mt-auto">
					<Placeholder.Button variant="primary" className="gray-transparent-btn rounded-pill" />
					<Placeholder.Button variant="primary" className="transparent-btn rounded-pill" />
					<Placeholder.Button variant="primary" className="skilled-btn rounded-pill" />
				</div>
			</Stack>
			<Stack className="applicants-list-box h-100">
				<div className="d-flex position-relative gap-3">
					<div className="applicants-info d-flex flex-column flex-sm-row align-items-sm-center gap-2 gap-md-3 flex-1">
						<div className="applicants-img rounded-circle"></div>
						<Stack className="gap-1 justify-content-center">
							<Placeholder animation="glow">
								<Placeholder xs={12} size="lg" />
								<Placeholder xs={12} size="sm" />
								<Placeholder xs={12} />
							</Placeholder>
						</Stack>
					</div>
					<div className="applicants-info-actions d-flex gap-3">
						<Placeholder.Button variant="primary" className="edit-btn p-0 rounded-circle" />
						<Placeholder.Button
							variant="primary"
							className="filled-btn fav-btn rounded-pill lh-1"
						/>
					</div>
				</div>
				<div className="applicants-description">
					<Placeholder animation="glow">
						<Placeholder xs={12} />
						<Placeholder xs={12} />
					</Placeholder>
				</div>
				<div className="applicants-about">
					<Placeholder animation="glow">
						<Placeholder xs={3} /> <Placeholder xs={4} />
					</Placeholder>
				</div>
				<div className="applicants-skills-list">
					<Placeholder animation="glow">
						<Placeholder xs={1} /> <Placeholder xs={1} /> <Placeholder xs={1} />{' '}
						<Placeholder xs={1} /> <Placeholder xs={1} /> <Placeholder xs={1} />{' '}
						<Placeholder xs={1} />{' '}
					</Placeholder>
				</div>
				<div className="applicants-actions d-flex gap-2 gap-md-3 flex-column flex-sm-row mt-auto">
					<Placeholder.Button variant="primary" className="gray-transparent-btn rounded-pill" />
					<Placeholder.Button variant="primary" className="transparent-btn rounded-pill" />
					<Placeholder.Button variant="primary" className="skilled-btn rounded-pill" />
				</div>
			</Stack>
		</>
	);
};

export default CandidateDetailSkeleton;
